import { Typography } from '@components/typography';
import { Container, Stack } from '@mui/material';
import { useEffect, useState } from 'react';

export const SystemNotificationBanner = ({ temp }: { temp?: string }) => {
  const [message, setMessage] = useState<string | null>(temp);

  useEffect(() => {
    // Skip if the system API URL is not configured (e.g. local dev)
    const systemApiUrl = process.env.GATSBY_SYSTEM_API_URL;
    if (!systemApiUrl) return;

    void fetch(systemApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `query getSystemNotifications {
      getSystemNotifications {
          message
          notificationId
      }
    }`,
      }),
    })
      .then((response) => {
        if (!response.ok) return undefined;
        return response.json();
      })
      .then((data: { data: { getSystemNotifications: { message: string } } } | undefined) => {
        const newMessage = data?.data?.getSystemNotifications?.message;
        if (newMessage) {
          setMessage(newMessage);
        }
      })
      .catch(() => {
        // Silently ignore — system notifications are non-critical
      });
  }, []);

  if (message) {
    return (
      <Stack bgcolor="#029EF2" width="100%">
        <Container
          maxWidth="md"
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: '24px' }}
        >
          <Typography
            style={{ color: '#000000', fontSize: '1rem', lineHeight: '1.5rem', fontWeight: 700 }}
          >
            {message}
          </Typography>
        </Container>
      </Stack>
    );
  }

  return <div />;
};
